var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-user"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    clipPath: "url(#clip-user)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_738",
    "data-name": "Ellipse 738",
    cx: 27.57,
    cy: 27.57,
    r: 27.57,
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 10.005, -4.267)",
    fill: "#f0f0f0",
    opacity: 0.999
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_User_Two-Tone_Emotions_Happy_",
    "data-name": "Icon/User/Two-Tone/Emotions/Happy ",
    transform: "translate(13.983 13.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15.517,0A15.517,15.517,0,1,0,31.034,15.517,15.517,15.517,0,0,0,15.517,0Z",
    fill: "#dd1ba7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M12.724.621a1.552,1.552,0,0,1,2.483,1.862A9.515,9.515,0,0,1,13.23,4.358,9.187,9.187,0,0,1,7.759,6.207,9.187,9.187,0,0,1,2.288,4.358,9.515,9.515,0,0,1,.31,2.483,1.552,1.552,0,1,1,2.793.621a6.591,6.591,0,0,0,1.32,1.228A6.131,6.131,0,0,0,7.759,3.1,6.131,6.131,0,0,0,11.4,1.849,7.44,7.44,0,0,0,12.524.86Z",
    transform: "translate(7.759 15.517)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9043815b28f1dbe38d026a73e91c1838.svg";
export { ForwardRef as ReactComponent };